import { render, staticRenderFns } from "./ClinicChDiagDic.vue?vue&type=template&id=3bda44d0"
import script from "./ClinicChDiagDic.vue?vue&type=script&lang=js"
export * from "./ClinicChDiagDic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bda44d0')) {
      api.createRecord('3bda44d0', component.options)
    } else {
      api.reload('3bda44d0', component.options)
    }
    module.hot.accept("./ClinicChDiagDic.vue?vue&type=template&id=3bda44d0", function () {
      api.rerender('3bda44d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicChDiagDic.vue"
export default component.exports